import {
  CustomTextArea,
  CustomTextField,
  DrawerFormSection,
} from '../../../../common/components';
import { invoiceFieldSpan } from '../SupplierLedgerShared';
import PaymentOrderProviderHeader from './PaymentOrderProviderHeader';

const PaymentOrderDataSection = ({ controller }) => {
  const { form, handleChange } = controller;

  return (
    <>
      <PaymentOrderProviderHeader controller={controller} />
      <DrawerFormSection title="Datos de la orden">
        <CustomTextField
          label="Fecha"
          type="date"
          name="emission_date"
          value={form.emission_date}
          onChange={handleChange}
          shrinkLabel
          sx={invoiceFieldSpan(4, 2)}
        />
        <CustomTextArea
          label="Observaciones"
          name="observations"
          value={form.observations}
          onChange={handleChange}
          minRows={3}
          maxRows={5}
          sx={invoiceFieldSpan(8, 2)}
        />
      </DrawerFormSection>
    </>
  );
};

export default PaymentOrderDataSection;
